/* eslint-disable @typescript-eslint/no-explicit-any */
import { subscribeShareRecord } from "@/services/share";

export const recordShare = async (shareId: string) => {
  try {
    await subscribeShareRecord(shareId);
  } catch (error: any) {
    console.log("recordShare error >>>>", error);
  }
};
